"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.process = void 0;
const _1 = require(".");
const process = (formsToProcess) => {
    const processedFormsConditions = [];
    const processedFormsOrdinals = [];
    const processedForms = formsToProcess.map((form) => (0, _1.processForm)(form, processedFormsConditions, processedFormsOrdinals));
    return { processedForms, processedFormsConditions, processedFormsOrdinals };
};
exports.process = process;
